import { Locale } from 'moment'
import { CountryCode } from '../countryCodes'

const filenames: IFileNames = {
  /* eslint-disable @typescript-eslint/camelcase */
  bg: import('moment/locale/bg'),
  cz: import('moment/locale/cs'),
  de: import('moment/locale/de'),
  el: import('moment/locale/el'),
  en: import('moment/locale/en-gb'),
  es: import('moment/locale/es'),
  fil: import('moment/locale/tl-ph'),
  fr: import('moment/locale/fr'),
  hr: import('moment/locale/hr'),
  hu: import('moment/locale/hu'),
  in: import('moment/locale/id'),
  it: import('moment/locale/it'),
  ja: import('moment/locale/ja'),
  ko: import('moment/locale/ko'),
  ms: import('moment/locale/ms'),
  pl: import('moment/locale/pl'),
  pl_PL: import('moment/locale/pl'),
  pt: import('moment/locale/pt'),
  pt_BR: import('moment/locale/pt-br'),
  ro: import('moment/locale/ro'),
  ru: import('moment/locale/ru'),
  se: import('moment/locale/sv'),
  th: import('moment/locale/th'),
  tr: import('moment/locale/tr'),
  uk: import('moment/locale/uk'),
  /* eslint-enable */
}

export default function(lng: CountryCode): Promise<Locale> {
  return filenames[lng]
}

const localeNames: ILocaleNames = {
  /* eslint-disable @typescript-eslint/camelcase */
  bg: 'bg',
  cz: 'cs',
  de: 'de',
  el: 'el',
  en: 'en-gb',
  es: 'es',
  fil: 'tl-ph',
  fr: 'fr',
  hr: 'hr',
  hu: 'hu',
  in: 'id',
  it: 'it',
  ja: 'ja',
  ko: 'ko',
  ms: 'ms',
  pl: 'pl',
  pl_PL: 'pl',
  pt: 'pt',
  pt_BR: 'pt-br',
  ro: 'ro',
  ru: 'ru',
  se: 'sv',
  th: 'th',
  tr: 'tr',
  uk: 'uk',
  /* eslint-enable */
}

export function mapCodeToMomentCode(lng: CountryCode): string {
  return localeNames[lng]
}

type IFileNames = { [key in CountryCode]?: Promise<Locale> }
type ILocaleNames = { [key in CountryCode]?: string }
